import FormField from '@ingka/form-field';
import Select, { Option } from '@ingka/select';
import type { Control, Path } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { BaseLotteryInput } from '@lotta/self-service/lottery-fe/types-form';
import { shouldValidate } from '../../utils';
import { FormFieldChildren } from '../controlled-year-month-dropdown/FormFieldChildren';

type Values = Pick<BaseLotteryInput, 'drawTime'>;

export type ControlledDrawTimeDropdownProps<TFormData extends Values = Values> = {
  control: Control<TFormData>;
  name: Path<TFormData>;
  errorMessage: string | undefined;
  disabled?: boolean;
  timeZone: string;
};

export const ControlledDrawTimeDropdown = <TFormData extends Values = Values>({
  control,
  name,
  disabled = false,
  errorMessage,
  timeZone,
}: ControlledDrawTimeDropdownProps<TFormData>) => {
  const { t } = useTranslation();

  let transformedErrorMessage = '';

  if (errorMessage) {
    transformedErrorMessage = `${t(errorMessage)}`;
  }

  if (errorMessage) {
    errorMessage = `${t(errorMessage)}`;
  }

  const hours: string[] = Array.from(
    { length: 24 },
    (_, i) => i.toString().padStart(2, '0') + ':00'
  );

  return (
    <Controller
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => {
        return (
          <FormField
            shouldValidate={shouldValidate(error)}
            valid={!transformedErrorMessage}
            validation={{
              msg: transformedErrorMessage,
              type: 'error',
            }}
          >
            <FormFieldChildren
              render={(describedById) => (
                <Select
                  id="lottery-form-draw-time"
                  describedById={describedById}
                  label={`${t('lottery-form-draw-time-dropdown')} (${timeZone})`}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    if (selectedValue !== 'HH:MM') {
                      onChange(e);
                    } else {
                      onChange({ target: { value: undefined } });
                    }
                  }}
                  onBlur={onBlur}
                  disabled={disabled}
                  hintText={`HH:MM (${timeZone})`}
                  value={value === '' ? undefined : value}
                >
                  {hours.map((hour) => (
                    <Option key={hour} value={hour} name={hour} />
                  ))}
                </Select>
              )}
            />
          </FormField>
        );
      }}
      name={name}
      control={control}
    />
  );
};
